export default "__VITE_ASSET__ZeNrhfe4__"